import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { useKeycloak } from '@react-keycloak/web'
import SubscriptionServices from '../../../../Services/Consumers/SubscriptionServices'

const DeleteExternalEntityGroup = ({ index, data, setData, count, setCount, handleNotificationCall, handleDeleteDialog, viewDeleteDialog, openDeleteDialog }) => {
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [formLoading, setFormLoading] = React.useState(false)

  const handleDelete = () => {
    setFormLoading(true)
    SubscriptionServices.deleteExternalEntityGroup(data[index].id, {
      headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
    }, setFormLoading).then((result) => {
      if (!!result && !!result.data && result.data.status.code === 200) {
        let newData = data.filter((item, i) => i !== index)
        setData(newData)
        setCount(count - 1)
        handleNotificationCall({
          type: 'defence',
          message: intl.formatMessage({ id: 'ExternalEntityGroup.Delete.FormSuccessAlert' }),
          color: 'success'
        }, 'success')
        handleDeleteDialog()
      } else {
        let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
        if (result.response && result.response.data) {
          if (result.response.data && result.response.data.status && result.response.data.status.errors) {
            message = result.response.data.status.errors
          }
        }
        handleNotificationCall({
          type: 'defence',
          message: message,
          color: 'error'
        }, 'error')
      }
    })
  }

  return (
    viewDeleteDialog &&
    <Dialog
      open={openDeleteDialog}
      onClose={handleDeleteDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage id='Page.Action.Delete'/>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormattedMessage
            id='ExternalEntityGroup.DeleteMessage'
            values={{ title: data[index].name }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeleteDialog} color="primary" disabled={formLoading}>
          <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
        </Button>
        <Button onClick={handleDelete} color="primary" autoFocus disabled={formLoading}>
          <FormattedMessage id='Page.Action.Delete'/>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteExternalEntityGroup

